var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');
var FindASpecialist = require('../../find-a-specialist/components/layout/findASpecialist.jsx');
var specialistsActions = require('../../../modules/specialists/actions/specialists');
var specialistActions = require('../../../modules/specialists/actions/specialist');
var findASpecialistMetaActions = require('../../../modules/meta/actions/find-a-specialist');


var SpecialistModal = createReactClass({

	onClose: function() {
		this.props.hideModal();
	},

    componentWillReceiveProps: function(nextProps){
        if(nextProps.specialist.mySpecialist && nextProps.specialist.mySpecialist._id !== this.props.specialist.mySpecialist._id){
            this.onClose();
        }
    },

	render: function() {
    var id = this.props.modal.props.id || 'specialist';

		return (
		  <Modal onClose={this.onClose} id={id}>
		     <FindASpecialist
                 token={this.props.auth.token}
				 error={this.props.specialists.error}
				 clearError={this.props.clearSpecialistsError}
                 clickTracking={this.props.recordFindASpecialistClick}
                 {...this.props} />
		  </Modal>
		);
	}

});

var mapStateToProps = function(state){
    return {
        auth: state.auth,
        specialists: state.specialists,
        specialist: state.specialist
    };
}

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(Object.assign({}, modalActions, specialistsActions, specialistActions, findASpecialistMetaActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(SpecialistModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/specialistModal.jsx